import React, { useState } from 'react';
import { List, Typography } from "@mui/material";
import InvoiceReport from '../../components/reports/modals/InvoiceReport';

const ReportsPage = () => {
    // const [type, setType] = useState([]);

    return (
        <>
            <Typography variant="h4">Reports</Typography>
            <List>
              <InvoiceReport />
            </List>
        </>
    );
};

export default ReportsPage;
